import { render } from "./AnnotationSetActionButtons.vue?vue&type=template&id=24255449&scoped=true"
import script from "./AnnotationSetActionButtons.vue?vue&type=script&lang=js"
export * from "./AnnotationSetActionButtons.vue?vue&type=script&lang=js"

import "../../assets/scss/annotation_action_buttons.scss?vue&type=style&index=0&id=24255449&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24255449"]])

export default __exports__